<template>
  <ListItem>
    <template #media>
      <div class="list-item-employee-media m-rounded-icon">
        <BaseIcon
          icon="user"
        />
      </div>
    </template>
    <h4 class="m-font-size-100">{{ employee.name }}</h4>
    <div class="list-item-employee-list">
      <p>#{{ employee.id }}</p>
      <p>&bull;</p>
      <p class="m-color-gray-600">{{ employee.jobTitle }}</p>
    </div>
  </ListItem>
</template>

<script setup>
import ListItem from '@/components/ListItem.vue';
import BaseIcon from '@/components/BaseIcon.vue';

defineProps({
  employee: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style scoped>
.list-item-employee-media {
  background-color: var(--gray-200);
}

.list-item-employee-list {
  display: flex;
  gap: 8px;
}

</style>
